import messages from "@smartmixin/i18n/dist/translations/ar.json";

export default messages;
